import React, {Component} from "react";

export class Contact extends Component {
	render() {
		return (
			<div>
				<div id="contact">
					<div className="container">
						<div className="col-md-12">
							<div className="text-center">
								<h2>Get In Touch</h2>
							</div>

							<div className="row justify-content-center">
								<div className="social">
									<ul>
										<li>
											<a
												href={this.props.data ? this.props.data.email : "/"}
											>
												<i className="fa fa-envelope"></i>
											</a>
											<span className={"download-space"}></span>
											<a
												href={this.props.data ? this.props.data.instagram : "/"}
											>
												<i className="fa fa-instagram"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="footer">
					<div className="container text-center">
						<p>
							&copy; 2021, myHrs, a LEXURY GROUP LLC Product
						</p>
						<p>
							<a href={"/tos"}>
								Terms of Service
							</a>
							<span className={'download-space'}></span>
							<a href={"/privacy"}>
								Privacy Policy
							</a>
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact.jsx